import { getSavedState, saveState } from './helpers.js';

export default {
    namespaced: true,

    state: () => ({
        pages: getSavedState('viewablePages'),
    }),

    getters: {
        pages(state) {
            return state.pages;
        },
    },

    mutations: {
        SET_PAGES(state, newValue) {
            state.pages = newValue;
            saveState('viewablePages', newValue);
        },
    },

    actions: {
        setPages({ commit }, newValue) {
            commit('SET_PAGES', newValue);
        },
    },
};